define('app-SearchResults/modules/framework/module',['text!./view.html', 'text!./viewCruise.html', '../../../app/utilities/urlKey'],
        function (view, viewCruise, UrlKey) {
            return {
                initialise: function (globalSettings) {
                    window.loadedModules('Framework (SearchResults)');
                    var framework = view;
                    if ($("body").hasClass("cruise")) {
                        framework = viewCruise;
                    }

                    $(framework).hide();
                    $(globalSettings.overallContainer).append(framework);
                    $(framework).slideDown(50);

                    var urlKey = new UrlKey();

                    setInterval(function () {
                        var name = urlKey.Get(globalSettings.searchNameKey);
                        if (name) {
                            var currentName = $('.blurOverlay h1').text();
                            if (name !== currentName) {
                                $('.blurOverlay h1').text(name)
                            }
                        }

                    }, 100);


                }
            };
        });
